import { DynamicFormConfig, FieldTypeEnum, FlexLayoutConfig, SlideToggleFieldConfig } from "@mydocma/dynamic-form";

export enum AttachmentFieldEnum  {
  fileName = 'fileName',
  imageDate = 'imageDate',
  comment = 'comment',
}


export const attachmentFileNameFieldConfig: SlideToggleFieldConfig = {
  id: AttachmentFieldEnum.fileName,
  name: AttachmentFieldEnum.fileName,
  label: {
    text: 'MM.report.tabs.options.fileName'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const attachmentImageDateFieldConfig: SlideToggleFieldConfig = {
  id: AttachmentFieldEnum.imageDate,
  name: AttachmentFieldEnum.imageDate,
  label: {
    text: 'MM.report.tabs.options.imageDate'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};

export const attachmentCommentFieldConfig: SlideToggleFieldConfig = {
  id: AttachmentFieldEnum.comment,
  name: AttachmentFieldEnum.comment,
  label: {
    text: 'MM.report.tabs.options.comment'
  },
  type: FieldTypeEnum.slidetoggle,
  value: true
};


export const attachmentLayout: FlexLayoutConfig = {
  name: 'attachmentLayout',
  cols: [
    {
      col: 0,
      flex: '50'
    },
    {
      col: 1,
      flex: '50'
    }
  ],
  rows: [],
  fields: [
    {
      fieldName: AttachmentFieldEnum.fileName,
      col: 0,
      row: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: AttachmentFieldEnum.imageDate,
      col: 0,
      row: 1,
      layoutAlign: 'start center'
    },
    {
      fieldName: AttachmentFieldEnum.comment,
      col: 0,
      row: 2,
      layoutAlign: 'start center',
    }

  ]
}

export const attachmentLayoutMobile: FlexLayoutConfig = {
  name: 'attachmentLayoutMobile',
  cols: [
    {
      col: 0,
      flex: '50'
    },
    {
      col: 1,
      flex: '50'
    }
  ],
  rows: [],
  fields: [
    {
      fieldName: AttachmentFieldEnum.fileName,
      col: 0,
      row: 0,
      layoutAlign: 'start center'
    },
    {
      fieldName: AttachmentFieldEnum.imageDate,
      col: 0,
      row: 1,
      layoutAlign: 'start center'
    },
    {
      fieldName: AttachmentFieldEnum.comment,
      col: 0,
      row: 2,
      layoutAlign: 'start center',
    }

  ]
}



export const attachmentFormConfig: DynamicFormConfig = {
  fields: [
    attachmentFileNameFieldConfig,
    attachmentImageDateFieldConfig,
    attachmentCommentFieldConfig,
  ],
  layouts: [attachmentLayout, attachmentLayoutMobile],
};

